import { Plus, Minus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import type { PublicProduct } from "@/hooks/usePublicMenu";

interface PublicProductCardProps {
  product: PublicProduct;
  quantity: number;
  onAdd: () => void;
  onRemove: () => void;
}

export function PublicProductCard({ product, quantity, onAdd, onRemove }: PublicProductCardProps) {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(price);
  };

  return (
    <Card className="overflow-hidden flex flex-row h-28">
      {product.image_url && (
        <div className="w-28 h-full flex-shrink-0">
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
        <div>
          <h3 className="font-medium text-sm line-clamp-1">{product.name}</h3>
          {product.description && (
            <p className="text-xs text-muted-foreground line-clamp-2 mt-0.5">
              {product.description}
            </p>
          )}
        </div>
        <div className="flex items-center justify-between gap-2">
          <span className="font-semibold text-primary text-sm">
            {formatPrice(product.price)}
          </span>
          <div className="flex items-center gap-1">
            {quantity > 0 ? (
              <>
                <Button
                  variant="outline"
                  size="icon"
                  className="h-7 w-7"
                  onClick={onRemove}
                >
                  <Minus className="h-3 w-3" />
                </Button>
                <span className="w-6 text-center text-sm font-medium">{quantity}</span>
                <Button
                  size="icon"
                  className="h-7 w-7"
                  onClick={onAdd}
                >
                  <Plus className="h-3 w-3" />
                </Button>
              </>
            ) : (
              <Button
                size="sm"
                className="h-7 text-xs"
                onClick={onAdd}
              >
                <Plus className="h-3 w-3 mr-1" />
                Adicionar
              </Button>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
}
